import React from "react";
import cs from "classnames";
import styles from "./style/index.module.less";

const COLORS = [
  "#f44336",
  "#e91e63",
  "#9c27b0",
  "#673ab7",
  "#3f51b5",
  "#2196f3",
  "#03a9f4",
  "#00bcd4",
  "#009688",
  "#4caf50",
  "#8bc34a",
  "#cddc39",
  "#ffeb3b",
  "#ffc107",
  "#ff9800",
  "#ff5722",
];

function hashString(str: string) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return hash;
}

function getColor(text: string, color?: string) {
  if (color) {
    return color;
  }
  if (!text) {
    return COLORS[0];
  }
  const hash = hashString(text.toLowerCase());
  return COLORS[Math.abs(hash) % COLORS.length];
}

export type CircleAvatarProps = React.HTMLAttributes<HTMLDivElement> & {
  text?: string;
  size?: number;
  color?: string;
  charCount?: number;
};

function CircleAvatar(props: CircleAvatarProps) {
  const {
    text = "U",
    size = 40,
    color,
    charCount = 1,
    className,
    style,
    children,
    ...rest
  } = props;
  const trimmed = text.trim();
  const displayChar = trimmed
    ? trimmed.slice(0, Math.max(1, charCount)).toUpperCase()
    : "U";
  const dimension = typeof size === "number" ? size : parseFloat(String(size));
  const fontSize = Math.floor(dimension * (displayChar.length > 1 ? 0.3 : 0.4));

  const mergedStyle: React.CSSProperties = {
    width: dimension,
    height: dimension,
    fontSize,
    backgroundColor: getColor(trimmed, color),
    ...style,
  };

  return (
    <div className={cs(styles.avatar, className)} style={mergedStyle} {...rest}>
      {children || displayChar}
    </div>
  );
}

export default CircleAvatar;
